module.exports = __webpack_public_path__ + "img/icon1.240fafd8.png";